import { render, staticRenderFns } from "./profitTableSpecialty2.vue?vue&type=template&id=33c390dc&scoped=true"
import script from "./profitTableSpecialty2.vue?vue&type=script&lang=js"
export * from "./profitTableSpecialty2.vue?vue&type=script&lang=js"
import style0 from "./profitTableSpecialty2.vue?vue&type=style&index=0&id=33c390dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c390dc",
  null
  
)

export default component.exports